"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _table = _interopRequireDefault(require("../../../core/table"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("th", null, "RTC");
var _ref2 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Bib");
var _ref3 = /*#__PURE__*/_react.default.createElement("th", null, "Name");
var _ref4 = /*#__PURE__*/_react.default.createElement("th", null, "Ranking");
var _ref5 = /*#__PURE__*/_react.default.createElement("th", null, "Age");
var _ref6 = /*#__PURE__*/_react.default.createElement("th", null, "Club");
var _ref7 = /*#__PURE__*/_react.default.createElement("th", null);
class EntriesList extends _react.Component {
  render() {
    const divisionsById = {};
    const divisions = [];
    for (const race of this.props.races) {
      if (!divisionsById[race.competitionDivision.id]) {
        divisions.push(divisionsById[race.competitionDivision.id] = {
          ...race.competitionDivision,
          races: []
        });
      }
      divisionsById[race.competitionDivision.id].races.push(race);
    }
    return /*#__PURE__*/_react.default.createElement("div", null, divisions.map(division => /*#__PURE__*/_react.default.createElement("div", {
      key: division.id
    }, division.races.filter(r => r.completedEntries.length && r.eligibilities.length).map(race => /*#__PURE__*/_react.default.createElement("div", {
      key: race.id
    }, /*#__PURE__*/_react.default.createElement("h4", null, race.raceName, " (", race.completedEntries.length, race.completedEntries.length === 1 ? ' entry' : ' entries', ")"), /*#__PURE__*/_react.default.createElement(_table.default, null, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, _ref, _ref2, _ref3, division.isRanking ? null : _ref4, _ref5, _ref6, !this.props.displayFreeCode ? null : _ref7)), /*#__PURE__*/_react.default.createElement("tbody", null, race.completedEntries.map(entry => /*#__PURE__*/_react.default.createElement("tr", {
      key: entry.id
    }, /*#__PURE__*/_react.default.createElement("td", null, entry.rtcRefs.join('')), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, entry.startListBib), /*#__PURE__*/_react.default.createElement("td", null, entry.bibName), division.isRanking ? null : /*#__PURE__*/_react.default.createElement("td", null, (entry.bibNumber ? entry.rankingDivisionDescription + ' ' : '') + entry.classDescription + ' ' + (entry.bibNumber || '')), /*#__PURE__*/_react.default.createElement("td", null, entry.ageCategoryDescription), /*#__PURE__*/_react.default.createElement("td", null, entry.entryText), !this.props.displayFreeCode ? null : /*#__PURE__*/_react.default.createElement("td", null, entry.freeCode))))))))));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}
_defineProperty(EntriesList, "partials", {
  Races: {
    id: true,
    raceName: true,
    eventDescription: true,
    competitionDivision: {
      id: true,
      description: true,
      isRanking: true
    },
    eligibilities: {
      id: true
    },
    completedEntries: {
      id: true,
      bibNumber: true,
      startListBib: true,
      bibName: true,
      entryText: true,
      ageCategoryDescription: true,
      classDescription: true,
      rankingDivisionDescription: true,
      rtcRefs: true,
      freeCode: true
    }
  }
});
var _default = exports.default = EntriesList;